import { Table } from '@factorialco/deprecated-design-system'
import {
  EmployeeCustomTablesResourceValueFragment,
  EmployeeCustomTablesSchemaFragment,
  EmployeeCustomTablesSchemaResourceFieldFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import TableBodyRow from './_Row'

interface Props {
  schema: EmployeeCustomTablesSchemaFragment
  sortedFields: EmployeeCustomTablesSchemaResourceFieldFragment[]
  attachableId: string
  currency: string
  filteredResourceValues: EmployeeCustomTablesResourceValueFragment[]
}

const TableBodyComponent = ({
  schema,
  sortedFields,
  filteredResourceValues,
  attachableId,
  currency,
}: Props) => {
  const hasValues = filteredResourceValues.length > 0

  return (
    <Table.Body>
      {!hasValues && (
        <Table.Blank colSpan={schema.fields.length + 1} text={i18n.t('custom_tables.empty')} />
      )}
      {filteredResourceValues.map((value, key) => {
        return (
          <TableBodyRow
            key={key}
            sortedFields={sortedFields}
            attachableId={attachableId}
            schema={schema}
            value={value}
            currency={currency}
          />
        )
      })}
    </Table.Body>
  )
}

export default observer(TableBodyComponent)
